import PropTypes from "prop-types";
import isEqual from "lodash/isEqual";

export default function BaseFoo(react) {
  class Foo extends react {
    __isMounted = false;

    _timeout = null;
    _lazyDelay = null;
    _debug = false;

    state = {
      isLoading: false,
      dummy: false,
      mountLazy: false
    };

    get _isMounted() {
      return this.__isMounted;
    }

    constructor(props) {
      super(props);

      this.showConsole("constructor");
    }

    _setMountLazy() {
      if (!this.state.mountLazy) this.setState({ mountLazy: true });
    }

    _reRender(callback) {
      this.setState({ dummy: !this.state.dummy }, callback);
    }

    showConsole(str) {
      this._debug &&
        console.log(
          str + " %c%s:",
          "color: #c41d7f;",
          this.constructor.name,
          this
        );
    }

    setMountLazy = () => {
      this._setMountLazy();
    };

    reRender = callback => {
      this._reRender(callback);
    };

    sortAscOrder = (a, b) => {
      return a.order - b.order;
    };

    sortAscModified = (a, b) => {
      return new Date(a.modified) - new Date(b.modified);
    };

    sortAscCreated = (a, b) => {
      return new Date(a.created) - new Date(b.created);
    };

    shouldFieldUpdate = (prevValues, curValues) => {
      return !isEqual(prevValues, curValues);
    };

    childComponentDidCatch(error, errorInfo) {}

    childComponentDidMount() {}

    childComponentWillUnmount() {}

    componentDidCatch(error, errorInfo) {
      console.error(error, errorInfo);
      this.childComponentDidCatch(...arguments);
    }

    componentDidMount() {
      this.showConsole("componentDidMount");
      this.__isMounted = true;

      if (this._lazyDelay && !this.state.mountLazy)
        this._timeout = setTimeout(this.setMountLazy, this._lazyDelay);

      if (this.props.onRef) this.props.onRef(this);

      this.childComponentDidMount();
    }

    componentWillUnmount() {
      this.showConsole("componentWillUnmount");
      this.__isMounted = false;

      if (this.props.onRef) this.props.onRef(undefined);

      this.childComponentWillUnmount();
      clearTimeout(this._timeout);
    }

    render() {
      this.showConsole("render");

      return null;
    }
  }

  Foo.propTypes = {
    onRef: PropTypes.func
  };

  Foo.defaultProps = {
    onRef: () => null
  };

  return Foo;
}



// WEBPACK FOOTER //
// ./src/App/component/Base/Base.js